import { render } from "./AppSectionWindow.vue?vue&type=template&id=24482788&scoped=true&ts=true&lang=pug"
import script from "./AppSectionWindow.vue?vue&type=script&lang=ts"
export * from "./AppSectionWindow.vue?vue&type=script&lang=ts"

import "./AppSectionWindow.vue?vue&type=style&index=0&id=24482788&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24482788"]])

export default __exports__